import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { SharedService } from '../../shared.service';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css']
})
export class CustomersComponent implements OnInit {

  searchString: any = '';
  sortby: any = 'pltNo';
  customers = [] as any;
  project: any;
  currentUser:any;

  isloading= true;

  constructor(
    private router: Router,
    private SharedService: SharedService
  ) {

  }

  ngOnInit(){
    this.project = this.SharedService.getProject();
    this.currentUser = this.SharedService.getUser();
    this.customers = [];

    this.SharedService.customersList(this.project.id).subscribe((response:any)=>{
      // console.log(response);
      if(this.currentUser.role === 'admin' || this.currentUser.role === 'manager'){
        this.customers = response.data;
      }else{
        response.data.forEach(customer => {
          if(customer.sale_person?._id === this.currentUser._id){
            this.customers.push(customer)
          }
        });
      }

      this.isloading = false;
    })
  }

  @ViewChild('customerTable') customerTable: ElementRef;
  export():any{
    console.log(this.customerTable.nativeElement);
    this.SharedService.export(this.customerTable.nativeElement,'all-customers-list');
  }

  info(event) {
    this.router.navigate(['dashboard/sales/details'],{ fragment: event.toString() });
  }

  delete(user: any): any {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you really want to delete user ' + user.name,
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        if(user.status.toLowerCase() === user.property?.status.toLowerCase()){
          alert("Cannot Delete as Customer hold's a property")
        }else{
          this.SharedService.deleteCustomer(user._id).subscribe(response => {
            console.log(response)
            this.Toast.fire({
              title: 'Deleted!',
              text: 'The user has been deleted',
              icon: 'success'
            })
            this.ngOnInit();
          },
          (error)=>{
            console.log(error);
            this.Toast.fire({
              title: 'Error!',
              text: error.error,
              icon: 'error',
            });
          })
        }

      }
    })
  }

  Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })


}
